module.exports = __webpack_public_path__ + "e708fc24df88a6bdbfac2f72222fa822.svg";